import { Auth } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// AdminAuthServices contains functions to interact with the authentication-related APIs for the admin module.
// Each function corresponds to a specific API endpoint for tasks such as login, password change, forgot password, etc.
export const AdminAuthServices = {
  /**
   * Function for user login.
   * @param {Object} values - User login credentials.
   * @returns {Promise<Object>} - A promise that resolves to the response from the login API.
   */
  adminLogin: async (values) => {
    try {
      const payload = {
        ...Auth.adminAccountLogin,
        bodyData: values,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for getting admin profile data.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get profile API.
   */
  getAdminProfileService: async () => {
    try {
      const payload = {
        ...Auth.getAdminProfile,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for updating admin profile with first name, last name, and email.
   * @param {Object} bodyData - Updated admin profile information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update profile API.
   */
  updateAdminProfileService: async (bodyData) => {
    try {
      const payload = {
        ...Auth.updateAdminProfile,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for changing password.
   * @param {Object} bodyData - Password change information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the change password API.
   */
  changePasswordService: async (bodyData) => {
    try {
      const payload = {
        ...Auth.changePassword,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for handling admin forgot password.
   * @param {Object} bodyData - User information for the forgot password process.
   * @returns {Promise<Object>} - A promise that resolves to the response from the forgot password API.
   */
  adminForgotPassword: async (bodyData) => {
    try {
      const payload = {
        ...Auth.accountForgot,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for updating admin profile information.
   * @param {Object} bodyData - Updated admin profile information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update profile API.
   */
  updateAdminService: async (bodyData) => {
    try {
      const payload = {
        ...Auth.accountUpdate,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for resetting password.
   * @param {Object} bodyData - Password reset information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the reset password API.
   */
  resetPasswordService: async (bodyData) => {
    try {
      const payload = {
        ...Auth.resetPassword,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for updating profile image.
   * @param {Object} bodyData - Updated profile image information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update profile image API.
   */
  updateProfileImageService: async (bodyData) => {
    try {
      const payload = {
        ...Auth.updateProfileImage,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for user logout.
   * @returns {Promise<Object>} - A promise that resolves to the response from the logout API.
   */
  logoutService: async () => {
    try {
      const payload = {
        ...Auth.accountLogout,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (err) {
      logger(err);
    }
  },


  /**
   * Function for admin getAdminDataService.
   * @returns {Promise<Object>} - A promise that resolves to the response from the admin detail API.
   */
  getAdminDataService: async () => {
    try {
      let payload = {
        ...Auth.getAdminDetails,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
